// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"933c28e3","878":"286ceb58"}[chunkId] + ".chunk.js";
};